export default __webpack_public_path__ + "static/media/cenaidjaxxx-color.e5baf45a.svg";